<div class="modal-header">
  <h4 class="modal-title">Import {{ entity }}</h4>
  <mat-icon class="close clickable" (click)="onClose()">close</mat-icon>
</div>

<div class="modal-body import-container">
  <!-- Top: Step indicators -->
  <div class="step-bar">
    <div class="step-item" [class.active]="currentStep === 1" [class.completed]="currentStep > 1">
      <div class="step-circle">
        <span *ngIf="currentStep <= 1">1</span>
        <mat-icon *ngIf="currentStep > 1" class="step-check">check</mat-icon>
      </div>
      <span class="step-label">Upload</span>
    </div>
    <div class="step-connector" [class.completed]="currentStep > 1"></div>
    <div class="step-item" [class.active]="currentStep === 2" [class.completed]="currentStep > 2">
      <div class="step-circle">
        <span *ngIf="currentStep <= 2">2</span>
        <mat-icon *ngIf="currentStep > 2" class="step-check">check</mat-icon>
      </div>
      <span class="step-label">Map</span>
    </div>
    <div class="step-connector" [class.completed]="currentStep > 2"></div>
    <div class="step-item" [class.active]="currentStep === 3">
      <div class="step-circle">3</div>
      <span class="step-label">Import</span>
    </div>
  </div>

  <!-- Main content area -->
  <div class="step-content">

    <!-- Step 1: Upload -->
    <div *ngIf="currentStep === 1">
      <h5 class="step-title">Upload File</h5>
      <p class="step-description">Select a CSV or Excel file to import.</p>
      <div class="upload-area">
        <input type="file" id="fileInput" (change)="onFileChange($event)" accept=".csv,.xlsx,.xls" class="file-input" />
        <label for="fileInput" class="upload-label">
          <mat-icon class="upload-icon">cloud_upload</mat-icon>
          <span>Choose File</span>
        </label>
        <span *ngIf="selectedFile" class="file-name">{{ selectedFile.name }}</span>
      </div>
      <div class="loader" *ngIf="loading">
        <mat-spinner diameter="32"></mat-spinner>
        <span class="ms-2">Reading file...</span>
      </div>
    </div>

    <!-- Step 2: Map columns -->
    <div *ngIf="currentStep === 2">
      <h5 class="step-title">Map Columns</h5>
      <p class="step-description">Map each CSV column to the corresponding system field.</p>
      <div class="required-fields-note" *ngIf="entity === 'Timesheets'">
        <mat-icon class="note-icon">info</mat-icon>
        <span>The following fields are required for timesheet import: <strong>Job</strong>, <strong>Start Date</strong>,
          <strong>End Date</strong>, and <strong>Contractor Email</strong>.</span>
      </div>

      <div class="import-status-selector" *ngIf="entity === 'Timesheets'">
        <label class="status-label">Import status:</label>
        <div class="status-options">
          <label class="status-option">
            <input type="radio" name="importStatus" value="submitted" [(ngModel)]="importStatus" />
            <span>Submitted</span>
          </label>
          <label class="status-option">
            <input type="radio" name="importStatus" value="approved" [(ngModel)]="importStatus" />
            <span>Approved</span>
          </label>
        </div>
      </div>

      <div class="mapping-list">
        <div class="mapping-row mapping-header">
          <div class="mapping-col csv-col">CSV Column</div>
          <div class="mapping-col arrow-col"></div>
          <div class="mapping-col field-col">System Field</div>
        </div>
        <div class="mapping-row" *ngFor="let header of headers; let i = index">
          <div class="mapping-col csv-col">
            <span class="csv-label">{{ headerLabels[i] }}</span>
          </div>
          <div class="mapping-col arrow-col">
            <mat-icon class="arrow-icon">arrow_forward</mat-icon>
          </div>
          <div class="mapping-col field-col">
            <select [(ngModel)]="columnMapping[headerLabels[i]]" [name]="'map_' + i" class="form-select form-select-sm">
              <option [ngValue]="null">-- Skip --</option>
              <option *ngFor="let field of systemFields" [value]="field.key">
                {{ field.label }}
              </option>
            </select>
          </div>
        </div>
      </div>

      <!-- Preview rows -->
      <div *ngIf="previewRows.length" class="preview-section">
        <h6 class="preview-title">Preview ({{ previewRows.length }} sample rows)</h6>
        <div class="table-responsive">
          <table class="table table-sm table-bordered mb-0">
            <thead>
              <tr>
                <th *ngFor="let header of headers; let i = index">{{ headerLabels[i] }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of previewRows">
                <td *ngFor="let header of headers">{{ row[header] }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- Step 3: Importing -->
    <div *ngIf="currentStep === 3" class="importing-state">
      <mat-spinner diameter="48"></mat-spinner>
      <p class="mt-3">Import in progress...</p>
    </div>

  </div>
</div>

<div class="modal-footer">
  <div class="mapping-error text-danger w-100 mb-2" *ngIf="mappingError">
    <mat-icon class="align-middle" style="font-size: 18px; height: 18px; width: 18px;">error_outline</mat-icon>
    <span class="ms-1">{{ mappingError }}</span>
  </div>
  <button type="button" class="btn btn-secondary" (click)="onClose()">Cancel</button>
  <button *ngIf="currentStep === 2" type="button" class="btn btn-primary" (click)="startImport()">
    Start Import
  </button>
</div>